module.exports = "/dist/images/vi.42784802.png";